import { GroupeActivite } from './GroupeActivite';
import { MobiDocument } from './MobiDocument';

export class HistoGroupeDocument extends MobiDocument{
    private _id : string;
    private _rev : string;
    private id : number;
    private dateeffet: string;
    private inscriptionan_id: string;
    private groupeactivite_id: string;


    public constructor(histoGroupe : any){
        super()
        this._id = histoGroupe._id;
        this._rev = histoGroupe._rev;
        this.id = histoGroupe.id
        this.dateeffet= histoGroupe.dateeffet;
        this.inscriptionan_id= histoGroupe.inscriptionan_id;
        this.groupeactivite_id= histoGroupe.groupeactivite_id;
    }


    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getDateeffet(): string {
        return this.dateeffet;
    }

    public setDateeffet(dateeffet: string): void {
        this.dateeffet = dateeffet;
    }

    public getInscriptionan_id(): string {
        return this.inscriptionan_id;
    }

    public setInscriptionan_id(inscriptionan_id: string): void {
        this.inscriptionan_id = inscriptionan_id;
    }

    public getGroupeactivite_id(): string {
        return this.groupeactivite_id;
    }

    public setGroupeactivite_id(groupeactivite_id: string): void {
        this.groupeactivite_id = groupeactivite_id;
    }


    public getGroupeActivite(): GroupeActivite{
        return this.memdb.findOne({
            doctype: "GroupeActiviteDocument",
            fkey: "id",
            fvalue: this.groupeactivite_id

        }) as GroupeActivite;
    }

}